"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useDictateInterims;

var _WebChatReduxContext = require("../WebChatReduxContext");

var _useWebChatUIContext = _interopRequireDefault(require("./internal/useWebChatUIContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function useDictateInterims() {
  return [(0, _WebChatReduxContext.useSelector)(function (_ref) {
    var dictateInterims = _ref.dictateInterims;
    return dictateInterims;
  }) || [], (0, _useWebChatUIContext.default)().setDictateInterims];
}